// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3vgdO","newExpiryDate":"styles_newExpiryDate__2goRq","footer":"styles_footer__2eJwj"};